var render = function render(){
  var _vm$selectedOption, _vm$selectedOption2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "data-select"
  }, [_c('p', {
    staticClass: "data-input",
    class: {
      on: _vm.listVisible,
      disabled: _vm.disabled
    },
    attrs: {
      "name": "type-select",
      "value": (_vm$selectedOption = _vm.selectedOption) === null || _vm$selectedOption === void 0 ? void 0 : _vm$selectedOption.value
    },
    on: {
      "click": _vm.show
    }
  }, [_vm._v(" " + _vm._s(((_vm$selectedOption2 = _vm.selectedOption) === null || _vm$selectedOption2 === void 0 ? void 0 : _vm$selectedOption2.label) || _vm.placeholder) + " ")]), _c('datalist', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.listVisible,
      expression: "listVisible"
    }],
    staticClass: "type-select",
    on: {
      "click": _vm.dataClick
    }
  }, _vm._l(_vm.options, function (_ref, index) {
    var label = _ref.label,
        value = _ref.value,
        select = _ref.select;
    return _c('option', {
      attrs: {
        "data-select": select,
        "data-index": index
      },
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(label))]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }